import baseStore from '../generic_store'

const base = baseStore('tours');

const state = {
    ...base.state,
    base_url: '/api/tours',
    resourceName: 'Tour',
    model: {
        translatable: {
            name: {
                fr: '',
                en: ''
            },
        },
        name: {
            fr: '',
            en: ''
        },
    },
};

const getters = {
    ...base.getters,
};

const mutations = {
    ...base.mutations,
};

const actions = {
    ...base.actions,
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
